import React, { useState } from "react";
import { Box, Typography, TextField, Button, Grid, Chip } from "@mui/material";
import { SERVICE_LABELS, formatSubscriptionDate } from "../adminUtils";

const SubscriptionFields = ({ service, sub, onSave, saving }) => {
    const [extendDays, setExtendDays] = useState("30");
    const [endDate, setEndDate] = useState("");

    if (!sub) {
        return (
            <Typography variant="body2" color="text.secondary">
                No {SERVICE_LABELS[service]} subscription configured yet. Save service config first, then set a subscription.
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 2, borderRadius: 2, bgcolor: "rgba(15,23,42,0.04)", border: "1px solid", borderColor: "divider" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Subscription</Typography>
                <Chip
                    size="small"
                    label={sub.is_expired ? "Expired" : `${sub.days_remaining ?? 0} days left`}
                    color={sub.is_expired ? "error" : "success"}
                    variant="outlined"
                />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Ends: {formatSubscriptionDate(sub.subscription_end)}
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={4}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Extend by days"
                        type="number"
                        value={extendDays}
                        onChange={(e) => setExtendDays(e.target.value)}
                        inputProps={{ min: 1 }}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Button
                        variant="outlined"
                        disabled={saving}
                        onClick={() => onSave(service, { extend_days: parseInt(extendDays, 10) || 30 })}
                    >
                        Extend
                    </Button>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Set end date"
                        type="datetime-local"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        size="small"
                        disabled={saving || !endDate}
                        onClick={() => onSave(service, { subscription_end: new Date(endDate).toISOString() })}
                    >
                        Set explicit end date
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SubscriptionFields;
